import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, formatMoney } from "../Helpers";
import { STR_BUY_NOW, STR_CASH, STR_FLOAT, STR_NORMAL_AGENT, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBSCRIPTION_HAS_EXPIRED, STR_SUPER_AGENT, STR_YOUR_REQUEST } from "../Strings";
import { MdCall, MdMessage, MdPerson, MdWhatsapp } from "react-icons/md";
import { FaMoneyBillTransfer, FaMoneyBillTrendUp } from "react-icons/fa6";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		appContext.navTo({
			item: "view",
			subItem: "agent_profile",
			extraItem: data.id,
		});
	}

	return (
		<div
			className=""
			onClick={view}
			style={{
				padding: "10px",
			}}
		>
			<h6
				style={{
					fontSize: "16px"
				}}
				className="font-semi-bold"
			>
				<MdPerson size={32}/>
				<br/>
				{data.agentName}
			</h6>

			<div className="text-end">
				<span
					className="badge bg-dark"
				>
					{data.agentType === 'normal_agent' ? STR_NORMAL_AGENT[appContext.language] : ""}
				</span>

				<span
					className="badge bg-primary"
				>
					{data.agentType === 'super_agent' ? STR_SUPER_AGENT[appContext.language] : ""}
				</span>

			</div>
			<hr/>
		</div>
	);
}
